module.exports = __webpack_public_path__ + "media/images/ohap_syllabus_off-b50abf409068c424e8fbb90bae5b2e50.png";